/**
 * Shared utilities for the workspace Integrations surface.
 *
 * Originally extracted from the retired `CiIntegrations.tsx` to avoid
 * duplication across `WebhookIntegrationBlock` and any future provider
 * block that needs to display timestamps. Post-#1153 consolidation the
 * primary consumer is `WebhookIntegrationBlock` (the GitHub block has
 * its own timestamp rendering via the install-details endpoint).
 *
 * #1227: switched from browser-local to the operator's preferred tz —
 * the caller threads `useUserTimezone()` through. The wrapper retains
 * a defensive "—" for missing / unparseable input that the shared
 * `formatLocalDateTime` doesn't carry (its missing-input return is
 * also "—", but invalid-string falls through to the raw value; this
 * helper's tighter contract is what its single call site expects).
 */
import { formatLocalDateTime } from '@/lib/utils'

export function fmtDate(value: string | undefined, tz: string): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '—'
  return formatLocalDateTime(d, tz)
}
